import { AmortizationReportReducerDispatch, AmortizationReportReduxTypes, CreateAmortizationReportReduxState } from "./types"

const CREATE_AMORTIZATION_REPORT_INITIAL_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateAmortizationReportReducer = (state: CreateAmortizationReportReduxState = CREATE_AMORTIZATION_REPORT_INITIAL_STATE, action: AmortizationReportReducerDispatch) => {
    switch (action.type) {
        case AmortizationReportReduxTypes.AMORTIZATION_REPORT :

            return {
                ...state,
                loading: true
            }
        case AmortizationReportReduxTypes.AMORTIZATION_REPORT_SUCCESS:

            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        case AmortizationReportReduxTypes.AMORTIZATION_REPORT_ERROR:

            return {
                ...state,
                error: action.payload.error,
                loading: false
            }
        default:
            return { ...state }
    }
}

export { CreateAmortizationReportReducer }